import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { IntegrationDetails } from '../../controllers/store/types.tsx';

export const getConnectionStatus = (cloudId: string): Promise<IntegrationDetails[]> =>
	fetchJson(`/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`, {
		method: 'GET',
	});
